var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1622.17,28a1.014,1.014,0,1,0,1.17,1A1.094,1.094,0,0,0,1622.17,28Zm3.83,0a1.014,1.014,0,1,0,1.17,1A1.1,1.1,0,0,0,1626,28Zm3.83,2a1.014,1.014,0,1,0-1.17-1A1.094,1.094,0,0,0,1629.83,30Zm4.4,2.645a8.995,8.995,0,1,0-4.58,4.581l4.4,0.76a0.761,0.761,0,0,0,.13.011,0.81,0.81,0,0,0,.59-0.262,0.959,0.959,0,0,0,.22-0.768Zm-1.66.034,0.59,3.389-3.48-.6a0.788,0.788,0,0,0-.47.065A7.243,7.243,0,1,1,1633.36,29a7.158,7.158,0,0,1-.71,3.123A0.9,0.9,0,0,0,1632.57,32.682Z",
    transform: "translate(-1617 -20)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.65182c4e.svg";
export { ForwardRef as ReactComponent };